
export function clearPhoneNumber(phone: string): string {
  const clearedPhone = phone.replace(/[^\d]/g, "");

  if (clearedPhone.length <= 11) {
    return '55'+clearedPhone;
  }

  return clearedPhone;
}